import Price, { formatPrice } from "components/Price/Price"
import LabelSale from "components/Product/LabelSale"
import ProductPrice from "components/Product/ProductPrice"
import _ from "lodash"
import { observer } from "mobx-react"
import React from "react"
import { Component } from "react"
import { Button, Table, Form, Icon, Input, Label, Segment, Image } from "semantic-ui-react"
import shop from "shop/shop"

import "style/OrderTable.scss"
import settingStore from "stores/settingStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"

const PRIMARY = "Variante"
const SECONDARY = "groesse"


@observer
export default class OrderTable extends Component {

	state = {
		quantity: 0,
		byProduct: {},
		noteByProduct: {},
		loading: false,
	}

	handleChange = ( variant, hash, value ) => {
		const {byProduct, noteByProduct} = this.state
		let ok = variant.validateCount( value )
		console.log("OK? ",variant.validateCount( value ))
		// let okNext = variant.validateCount( 1 + Number( value ) )
		// next addition will trigger max stock amount
		if ( !ok ) {
			noteByProduct[hash] = translate( "maximale Abnahme-Menge erreicht." )
		} else {
			delete noteByProduct[hash]
		}
		this.setState( {noteByProduct} )
		// current addition will trigger max stock
		if ( !ok ) return

		byProduct[hash] = value
		this.setState( {byProduct} )
		this.computeQuantity()
		this.calculateTotal()
	}

	mergeProductsWithCart() {
		const {byAttribute, variantMap} = this.props

		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]
		const firstKeys = Object.keys( firstDimension )
		const secondKeys = Object.keys( secondDimension )

		const {byProduct} = this.state

		firstKeys.forEach( firstKey => {
			secondKeys.forEach( secondKey => {
				const hash = `${firstKey}___${secondKey}`
				const variant = variantMap[hash]
				const inCart = variant && shop.cart.productsById.get( variant.map_id )
				if ( inCart && byProduct[hash] === undefined ) {
					byProduct[hash] = inCart.count
				}
			} )
		} )
		return byProduct
	}


	componentWillMount() {
		const {byAttribute, variantMap} = this.props
		if(!byAttribute) return
		const firstDimension = byAttribute[PRIMARY]
		const secondDimension = byAttribute[SECONDARY]

		function isLetter( str ) {
			return str.length === 1 && str.match( /[a-z]/i );
		}

		if(!firstDimension) return

		let firstKeys = Object.keys( firstDimension )
		const secondKeys = _.sortBy( Object.keys( secondDimension ), item => {
			let ordinal = ordinals[item]
			if ( ordinal ) return ordinal

			if ( isLetter( item[0] ) ) {
				return item
			} else {
				return parseInt( item )
			}
		} )

		const byProduct = this.mergeProductsWithCart()

		// const products = [...shop.cart.productsById.entries()].map( a => a[1] ).filter( product => {
		// 	return product.mainart === this.props.product.mainart
		// } )

		// FILTER EMPTY SETS
		firstKeys = firstKeys.filter( firstKey => {
			let products = secondKeys.filter( ( secondKey, index ) => {
				const hash = `${firstKey}___${secondKey}`
				const variant = variantMap[hash]
				return variant && variant.available
			} )
			return products.length > 0
		} )

		this.setState( {firstKeys, secondKeys, byProduct} )
	}

	computeQuantity() {
		const quantity = _.reduce( this.state.byProduct, ( a, b ) => {
			return Number( a ) + Number( b )
		}, 0 )
		this.setState( {quantity} )
	}

	calculateTotal() {
		const {variantMap} = this.props
		const {byProduct} = this.state
		let sum = 0
		_.map( byProduct, ( quantity, hash ) => {
			const product = variantMap[hash]
			if ( product ) {
				let price = quantity * product.price * product.unit_multi
				sum += price
			}
		} )
		return sum
	}

	handleSubmit = () => {
		this.setState( {loading: true} )
		const {quantity} = this.state
		const {variantMap} = this.props
		const sum = this.calculateTotal()
		let positionCount = 0
		const {byProduct} = this.state
		_.map( byProduct, ( quantity, hash ) => {
			const product = variantMap[hash]
			console.log( {quantity, hash} )
			if ( product ) {
				positionCount++
				product.count = quantity
				shop.cart.add( product )
			}
		} )

		setTimeout( () => {
				this.setState( {loading: false} )
				shop.toast( `<div>
<div>Warenkorb aktualisiert</div>
<div class="f6 ttu">${positionCount} Positionen ( ${formatPrice( sum )} € )  ${this.props.product.extraValue.stamm_art}</div>
</div>`, "info", false, "top" )
				console.log( "ADD:CART:ORDERTABLE", {byProduct} )
			}, 520
		)

	}

	render() {
		const {loading, secondKeys, firstKeys, noteByProduct} = this.state
		const {byAttribute, variantMap, variantProtoypeByKey, product} = this.props
		const byProduct = this.mergeProductsWithCart()
		const {productsById} = shop.cart
		if ( !byAttribute ) return <Segment loading/>
		let countByColumn = {}

		const sum = this.calculateTotal()

		return <div className="OrderTable">
			<Form onSubmit={this.handleSubmit}>
				<Table basic="very" compact>
					<Table.Body>
						<Table.Row>
							<Table.Cell width={"10%"}>
								<strong>{product.desc.short_des.split( "," )[0]}</strong>
							</Table.Cell>
							{secondKeys.map( key => {
								return <Table.Cell textAlign="center"
																	 key={key}>{key === "null" ? "uni" : key}</Table.Cell>
							} )}
							<Table.Cell width={2} textAlign="center">
								<div className=" ">{translate( "Stück" )}</div>
								<div className="black-60 f6 ">{translate( "Preis" )}</div>
							</Table.Cell>
						</Table.Row>

						{firstKeys.map( firstKey => {
							let count = 0
							const size = secondKeys.length
							const isTiny = size > 8  // should display a very tiny ui b/c so many variants
							let variant = false
							if ( variantProtoypeByKey[PRIMARY] && variantProtoypeByKey[PRIMARY][firstKey] ) {
								variant = variantProtoypeByKey[PRIMARY][firstKey]
							}
							return <Table.Row key={firstKey}>
								<Table.Cell width={3}>
									<div className={`flex ${isTiny ? "flex-column" : "flex-row"}`}>
										<div className="pr2 mw3 w-100">
											<div className="img-container">
												{variant && <Image className={"OrderTableImage"} centered src={variant.img_src_small}/>}
											</div>
										</div>
										<div className="">
											<div className="f6">{variant.article_nr}</div>
											<div className="f6 black-60"> {firstKey === "null" ? "uni" : firstKey}
											</div>
											{variant.isSale && <LabelSale currency={shop.session.value.currency ? shop.session.value.currency : 'EUR'} price={variant.originalPrice} percent={variant.salePercent}/>}
											{/*<span className="black"><Price>{variant.price}</Price></span>*/}
										</div>
									</div>

								</Table.Cell>
								{secondKeys.map( ( secondKey, index ) => {
									const hash = `${firstKey}___${secondKey}`
									const variant = variantMap[hash]
									const inCart = variant && shop.cart.productsById.get( variant.map_id )

									let addCount = variant && Number( byProduct[hash] ) || 0
									let verticalCount = countByColumn[index] || 0
									verticalCount += addCount
									countByColumn[index] = verticalCount
									if ( variant ) {
										const disabled = !variant.available
										if ( disabled ) {
											return <Table.Cell align="center" key={secondKey}>
												<div className="relative mw4 center">
													{/*<Input className="" disabled/>*/}
													{/*<div className={" tc  black-60 f7  bg-silver"}>*/}
													{/*  -*/}
													{/*</div>*/}
													<div className="tc black-20"><Icon name="close"/></div>
												</div>
											</Table.Cell>
										}

										count += Number( addCount )
										let productCount = ( byProduct[hash] !== undefined ) ? addCount : 0
										if ( productCount === undefined && inCart ) productCount = inCart.count
										if ( productCount === undefined ) productCount = 0

										return <Table.Cell align="center" className="relative" key={secondKey}>
											<div className={`OrderMatrixCell center w-100 flex flex-column ${isTiny ? "tiny" : "regular"} `}>
												<Input className=""
															 step={variant.unit_multi}
															 value={Number( productCount * variant.unit_multi )}
															 onBlur={e => {
																 let count = Math.ceil( e.target.value / variant.unit_multi )
																 this.handleChange( variant, hash, count )
															 }}
															 onChange={e => {
																console.log("OK ALL: e.target.value",e.target.value," / ", variant.unit_multi, "" )
																 let count = Math.ceil( e.target.value / variant.unit_multi )
																 console.log("OK count: ",count)
																 this.handleChange( variant, hash, count, )
															 }}>
													<input type="number" min="0" className="tc"/>
												</Input>
												{/*{inCart && <div className="absolute right-0 bottom-1 f7 black-60 bg-white pointer-events-none"><Label size={"tiny"} circular color="green"><Icon name={"shopping cart"}/></Label></div>}*/}
												<MetaBar product={variant} inCart={inCart} note={noteByProduct[hash]}/>

											</div>

										</Table.Cell>
									}

									if ( !variant ) return <Table.Cell textAlign="center" key={secondKey}>
										<div className="relative">
											<div className="relative mw4 center">
												{/*<Input className="" disabled/>*/}
												{/*<div className={" tc  black-60 f7  bg-silver"}>*/}
												{/*  -*/}
												{/*</div>*/}
												<div className="tc black-20"><Icon name="close"/></div>
											</div>
										</div>
									</Table.Cell>
								} )}
								<Table.Cell textAlign="right">
									<div>    {count && count || 0}</div>
									<div className="f6 black-60"><Price>{count && count * variant.price * variant.unit_multi || 0}</Price>
									</div>
								</Table.Cell>
							</Table.Row>
						} )}
						<Table.Row>
							<Table.Cell>
								<div>{translate( "Anzahl" )}</div>
								<div className="f7 tc ">&nbsp;</div>
							</Table.Cell>
							{secondKeys.map( ( key, index ) => {
								return <Table.Cell textAlign="center" key={key}>{countByColumn[index] || 0}</Table.Cell>
							} )}

							<Table.Cell textAlign="right">
								<div className="b f4">
									{
										_.reduce( byProduct, ( acc, value ) => {
											return acc + Number( value )
										}, 0 )
									}
								</div>
							</Table.Cell>
						</Table.Row>
					</Table.Body>
				</Table>
				<hr/>
				<Button loading={loading} disabled={loading} floated="right" color={"black"}><span
					className={"ttu"}><Icon
					name={"shopping cart"}/> {translate( "Aktualisieren" )} </span></Button>
			</Form>
		</div>
	}
}

const MetaBar = ( {product, inCart, note} ) => {
	let isVertreter = !!shop.session.handId
	const Note = product.getNotice( "tiny" )
	const cartCount = ( inCart && inCart.count ) ? inCart.count : 0
	const mode = settingStore.get( "orderMode" )

	let stock = product.stock
	let boxColor = null

	if ( !isVertreter ) {
		if ( stock >= 10 ) {
			stock = "10+"
		}
	}

	if ( stock >= 100 ) {
		stock = "99+"
	}

	if ( stock <= 0 ) {
		stock = false
	}

	if ( mode === "MODE_PREORDER" ) {
		stock = false
	}

	return <div className="MetaBar">
		<div className={"flex f6 black-60 flex-column items-center  justify-around ph2"}>
			<div className=" " title={translate( "Menge verfügbar" )}>
				{note && <span><Icon name="warning circle" title={note}/></span>}
				{( !note ) && <span>{stock ? stock : "_"} </span>}
			</div>
			<div>{Note}</div>
			{<div className={`db u-text-no-wrap ${!cartCount ? "black-30" : ""}`}>
				<span>{cartCount}&nbsp;<Icon title={`${cartCount} im Warenkorb`} name={"shopping cart"}/></span>
			</div>}
		</div>
		{/*<Note/>*/}
	</div>
}
//


const StockCount = ( {stock, warn = 2, className = ""} ) => {
	if ( stock > warn ) {
		return <Label color={"green"} className={` ${className}`}>{stock}</Label>
	}
	if ( stock <= warn && stock >= 1 ) {
		return <Label color={"yellow"} className={` ${className}`}>{stock}</Label>
	}
	return <Label className={`black-60 ${className}`}>{stock}</Label>
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/OrderTable/OrderTable.js